import ReverseIntegrationList from './reverse-integration.list';

export default {
  list: ReverseIntegrationList,
};
